enum ActionTypes {
  SET_MENU_OPENED = "SET_MENU_OPENED",
  SET_MENU_HIDDEN = "SET_MENU_HIDDEN",
}

export default ActionTypes;
